module.exports = __webpack_public_path__ + "img/chat-white.3c221417.svg";